import { render, staticRenderFns } from "./orderWxToHKshenpi.vue?vue&type=template&id=842668f0&scoped=true"
import script from "./orderWxToHKshenpi.vue?vue&type=script&lang=js"
export * from "./orderWxToHKshenpi.vue?vue&type=script&lang=js"
import style0 from "./orderWxToHKshenpi.vue?vue&type=style&index=0&id=842668f0&prod&scoped=true&lang=css"
import style1 from "./orderWxToHKshenpi.vue?vue&type=style&index=1&id=842668f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842668f0",
  null
  
)

export default component.exports